import React from "react";
var __jsx = React.createElement;
import { useStoreState } from "pullstate";
import Modal from "../common/Modal";
import Store from "../../utils/Store";
import Button from "../common/Button";
import RadioList from "../FormComponents/RadioList";
import constants from "../../utils/constants";
import { useEffect, useState } from "react";
import { fetchAndActivate, getRemoteConfig, getValue } from "firebase/remote-config";
import { firebaseApp } from "../../firebase/clientApp";
import Toast from "../Toast";
var RNEnvSelector = function RNEnvSelector() {
  var _useState = useState([]),
    envOptions = _useState[0],
    setEnvOptions = _useState[1];
  var _useStoreState = useStoreState(Store, function (store) {
      return {
        isRNEnvSelectorOpen: store.isRNEnvSelectorOpen,
        RNSelectedEnv: store.RNSelectedEnv
      };
    }),
    isRNEnvSelectorOpen = _useStoreState.isRNEnvSelectorOpen,
    RNSelectedEnv = _useStoreState.RNSelectedEnv;
  var _useState2 = useState(RNSelectedEnv),
    selectedEnv = _useState2[0],
    setSelectedEnv = _useState2[1];
  useEffect(function () {
    if (firebaseApp) {
      var _remoteConfig = getRemoteConfig(firebaseApp);
      _remoteConfig.settings.minimumFetchIntervalMillis = 30000;
      _remoteConfig.defaultConfig = require("./remote_config_defaults.json");
      fetchAndActivate(_remoteConfig).then(function () {
        var _getValue;
        var envs = JSON.parse((_getValue = getValue(getRemoteConfig(), "ENVIRONMENTS")) === null || _getValue === void 0 ? void 0 : _getValue.asString());
        var _envOptions = Object.keys(envs).map(function (env) {
          return {
            label: /*#__PURE__*/React.createElement("div", {
              className: "flex flex-col"
            }, /*#__PURE__*/React.createElement("div", null, env), /*#__PURE__*/React.createElement("div", {
              className: "text-sm text-gray-400"
            }, envs[env])),
            value: env
          };
        });
        setEnvOptions(_envOptions);
      })["catch"](function (err) {
        Toast.error("Unable to fetch remote config");
      });
    }
  }, []);
  useEffect(function () {
    setSelectedEnv(RNSelectedEnv);
  }, [RNSelectedEnv]);
  var onChange = function onChange(val) {
    setSelectedEnv(val);
  };
  var onClose = function onClose() {
    Store.update(function (s) {
      s.isRNEnvSelectorOpen = false;
    });
  };
  var onSelect = function onSelect() {
    if (selectedEnv) {
      var _window;
      (_window = window) === null || _window === void 0 || (_window = _window.ReactNativeWebView) === null || _window === void 0 || _window.postMessage(JSON.stringify({
        event: constants.RN_COMM_CONST.ENV_SELECTION,
        data: selectedEnv
      }));
      onClose();
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: isRNEnvSelectorOpen,
    onClose: onClose,
    title: "Select environment",
    className: "w-full sm:w-9/12 md:w-8/12 lg:w-6/12 xl:w-5/12",
    closeOnClickAway: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-gray-800 dark:text-gray-200 pb-6"
  }, /*#__PURE__*/React.createElement(RadioList, {
    options: envOptions,
    value: selectedEnv,
    onChange: onChange
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-100 text-base space-x-5"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: "grow-1 px-6 py-4"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    isPrimary: true,
    disabled: !selectedEnv,
    onClick: onSelect,
    className: "grow-1 px-6 py-4"
  }, "Select"))));
};
export default RNEnvSelector;